class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    document.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut(event) {
    const relatedTarget = event.relatedTarget;

    if (
      relatedTarget &&
      relatedTarget.closest('.header__dropdown__item__items')
    ) {
      return;
    }

    const headerDropdowns = document.querySelectorAll('.header__dropdown');

    headerDropdowns.forEach((headerDropdown) => {

      const detailsElements = headerDropdown.querySelectorAll('details');
      detailsElements.forEach((detailsElement) => {

        detailsElement.removeAttribute('open');
        const summaryElement = detailsElement.querySelector('summary');
        summaryElement.setAttribute('aria-expanded', 'false');

        // `.header__dropdown__item__items` altındaki linkleri yakala
        const dropdownItems = detailsElement.querySelectorAll(
          '.header__dropdown__item__items a'
        );
        dropdownItems.forEach((item) => {
          item.setAttribute('tabindex', '-1'); // odaklanılabilirliği kaldır
        });
      });
    });

    /*
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
    */
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
